import * as React from 'react';

function SvgUnitedKingdomUk(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 36 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 20.729h35.537V0H0V20.73z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.727 0L21.34 7.495h2.456L35.537.92V0h-.81zM23.24 13.65l12.297 6.882v-1.376l-9.84-5.506H23.24zM0 1.577l10.518 5.917h2.459L0 .201v1.376zM12.42 13.65L0 20.61v.12h2.244l12.634-7.079H12.42z"
        fill="#BD0034"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.663 0v6.968L33.105 0H20.663zM2.776 0l12.392 6.968V0H2.776zM27.096 7.494h8.44V2.74l-8.44 4.755zM27.096 13.65l8.44 4.705V13.65h-8.44zM3.479 20.729h11.69v-6.551l-11.69 6.55zM20.663 20.729h11.726l-11.726-6.551v6.55zM0 13.65v4.916l8.734-4.916H0zM0 7.494h8.734L0 2.571v4.923z"
        fill="#1A237B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.267 0v8.726H0v3.695h16.267v8.308h3.296v-8.308h15.974V8.726H19.563V0h-3.296z"
        fill="#BD0034"
      />
    </svg>
  );
}

export default SvgUnitedKingdomUk;
